import { useParams } from "react-router";
import { ChangeLog, ChangeLogView } from "src/components/change-log/ChangeLog";

export function DevelopmentChangeLogPage() {
  const { developmentId } = useParams<{ developmentId: string }>();

  return <ChangeLog view={ChangeLogView.Development} developmentId={developmentId} />;
}
